import React,{useState} from 'react'
import InputBox from '../../common/InputBox';
import SelectBox from '../../common/SelectBox';
import { Accordion, AccordionItem } from '@nextui-org/react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useFormContext } from '../../Context/FormContext';
import MailCopyCheckbox from '../../common/MailCopyCheckbox';
import authQueries from '../../queries/authQueries';
import { Spin, } from 'antd';
import CopyCheckbox from '../../common/CopyCheckbox';
import CustomInputBox from '../../common/CustomInputBox';
import { useForm, Controller } from "react-hook-form";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'
import CountryList from '../../common/CountryList';

const AdditionalInfo = ({setCurrent, current, navTab, setNavTab, shipType}) => {
  
  const [placement, setPlacement] = useState("outside") 
  const [radius, setRadius] = useState("sm")
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRankVisible, setIsRankVisible] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const { formData, updateFormData, formStates, updateFormStates } = useFormContext();

  const [checked, setChecked] = useState(false);

  const [code, setCode] = useState('in');


  const itemClasses = {
    base: "py-0 w-full",
    title: "font-normal text-medium",
    trigger: "px-2 py-0 rounded-lg h-14 flex items-center",
    indicator: "text-medium",
    content: "text-small px-2",
    overflow: "overflow-y-auto",
  };


  const validationSchema = yup.object({
    
    flag: yup
      .string()
      .required('Flag is required'),
    ship_type: yup
      .string()
      .required('Ship Type is required'), 
  });
    

const { register, reset, control, handleSubmit, formState: { errors }, setError, getValues, setValue} = useForm({});


const onSubmit = async(data) => {

  console.log(data)

  if(!data.ship_type_other && isVisible){

    return setError('ship_type_other', {type: 'custom', message: 'Other Ship Type is Required'})
    
  }
 
  await updateFormData(data);

  setNavTab(navTab + 1)
  // setCurrent(current + 1)

}

const toggleCheckbox = (e) => {

  const val = getValues()

  if(e.target.checked){
    setValue('crew_manager_email',val?.tech_manager_email? val?.tech_manager_email : '')
    setValue('crew_manager_phone',val?.tech_manager_phone? val?.tech_manager_phone : '')
  }
  else{
    setValue('crew_manager_email', '')
    setValue('crew_manager_phone', '')
  }

  console.log(getValues())



};


const handleChange = (e) => {
  console.log(e)
  const shipData = shipType?.data?.data?.items?.find(item => item?.id === e)

  const selectedShipId = e;

  updateFormData({ ship_type: e })

  if(shipData?.type === "Miscellaneous"){
    setIsVisible(true)
    updateFormStates({ isVisible: 'true' })
  }
  else{
    setIsVisible(false)
    updateFormStates({ isVisible: 'false' })
    setValue('ship_type_other', '')
    delete formData.ship_type_other;
    updateFormData((prevData) => {
      // Create a copy of the previous data
      const newData = { ...prevData };

      newData.ship_type = selectedShipId;

      // Remove rank_on_board_other and Others id
      delete formData.ship_type_other;

      return newData;
    });
  }
}

const inputItems = [
  
  // {
  //   label: "Flag",
  //   type: "text",
  //   component: InputBox,
  //   defaultValue: formData?.flag,
  //   col: "col-span-6",
  //   mandatory: false,
  //   name:"flag"
  // },
  {
    label: "Type Of Ship",
    type: "text",
    component: SelectBox,
    col: "col-span-6",
    mandatory: false,
    name:"ship_type",
    options: shipTypeOptionsCreate(shipType),
    selected: handleChange,
    maxLength:100
  },
  {
    label: "Other Ship Type",
    type: "text",
    component: InputBox,
    col: "col-span-4",
    mandatory: false,
    isVisible: isVisible,
    name:"ship_type_other",
    maxLength:100
  },
]

const inputAccordion1 = [
  {
    label: "Name of Employer / Technical Manager",
    radius: radius,
    type:"text",
    component: InputBox,
    defaultValue: formData?.tech_manager_name,
    col: "col-span-6",
    icon: 'icon-user',
    name:"tech_manager_name",
    mandatory: false,
    maxLength:100
  },
  {
      label: "Email Address of Contact Person",
      radius: radius,
      type:"email",
      component: InputBox,
      defaultValue: formData?.tech_manager_email,
      col: "col-span-6",
      icon: 'icon-envelope4',
      name:"tech_manager_email",
      mandatory: false,
      maxLength:100
  },
  // {
  //   label: "Phone Number of Contact Person",
  //   type: "number",
  //   component: CustomInputBox,
  //   defaultValue: formData?.tech_manager_phone,
  //   col: "col-span-6",
  //   name:"tech_manager_phone",
  //   mandatory: false,
  // }
]

const inputAccordion2 = [
  {
    label: "Name of Company",
    radius: radius,
    type:"text",
    component: InputBox,
    defaultValue: formData?.crew_manager_cmpny, 
    col: "col-span-6",
    icon: 'icon-office',
    name:"crew_manager_cmpny",
    mandatory: false,
    maxLength:100
  },
  {
    label: "Email Address of Contact Person",
    radius: radius,
    type:"email",
    component: InputBox,
    defaultValue: formData?.crew_manager_email,
    col: "col-span-6",
    icon: 'icon-envelope4',
    name:"crew_manager_email",
    mandatory: false,
    maxLength:100
  },
  // {
  //   label: "Phone Number of Contact Person",
  //   radius: radius,
  //   type: "number",
  //   component: CustomInputBox,
  //   defaultValue: formData?.crew_manager_phone,
  //   col: "col-span-6",
  //   icon: 'icon-dialpad',
  //   name:"crew_manager_phone",
  //   mandatory: false,
  // }
]




  return (

    <div>
      <Spin spinning={loading} size='large'>
        <div className="tab-pane mt-2 mb-4 p-2" id="step2">

            <h4 className='mb-2'>Additional Information</h4>
            <div className='mt-3 mb-4'>
            <small>
              <strong>Preferred but Optional - </strong> We would greatly appreciate it if you could provide us with the
              following information, even though it is optional. Doing so will help us expedite the process of
              resolving your issue. Please know that SHIPCONREP will keep this information confidential
              and will not share it with your employer.
            </small>
            </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='gap-4 grid grid-cols-12'>

              <CountryList  />
                
              {
                inputItems?.map((item, index) => {

                  if(item.name === "ship_type_other" && !isVisible) 

                  {return}

                  return(

                    <div key={index} className={`${item.col}`}>
                      <item.component
                        register={register}
                        name={item.name}
                        type={item.type}
                        label={item.label}
                        radius={radius}
                        placement={placement}
                        options={item.options}
                        description={placement}
                        selected={item.selected}
                        mandatory={item.mandatory}
                        error={errors}
                        maxLength={item.maxLength}
                      />

                    </div> 
                  ) 
                })
              }

            </div> 
            
            
         
            <div className='mt-4'>

            
                <Accordion
                    showDivider={false}
                    className='col-span-12 overflow-y-auto bg-[#fff] border border-slate-100 shadow-sm'
                    style={{fontSize:'12px' }}
                    variant="shadow"
                    itemClasses={itemClasses}
                  >
                    <AccordionItem
                      key="2"
                      className='text-sm overflow-y-auto'
                      aria-label="Apps Permissions"
                      title="Contact details of Technical Manager/ Person in Charge"
                    >
                     
                    <div className='gap-4 grid grid-cols-12 mb-4'>
                      
                      {
                        inputAccordion1?.map((item, index) => (
                          <div key={index} className={`${item.col} mt-3`}>
                            <item.component
                              register={register}
                              name={item.name}
                              type={item.type}
                              label={item.label}
                              radius={radius}
                              placement={placement}
                              options={item.options}
                              icon={item.icon}
                              maxLength={item.maxLength}
                            />
                          </div>  
                        ))
                      }
                    </div>
                    <div className='col-md-6 mb-4'>
                      <label className='mb-4'>Phone Number of Contact Person</label>
                      <Controller
                        name="tech_manager_phone"
                        control={control}
                        className="form-control"
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            enableSearch={true}
                            country={code}
                            onChange={(phoneValue, country) => {
                                setCode(country.countryCode)
                                onChange(phoneValue)
                            }}
                          />
                        )}
                      />
                    </div>
                  </AccordionItem>
                </Accordion>

                <Accordion
                    showDivider={false}
                    className='col-span-12 mt-2 bg-[#fff] border border-slate-100 shadow-sm '
                    style={{fontSize:'12px',}}
                    variant="shadow"
                    itemClasses={itemClasses}
                  >
                    <AccordionItem
                      key="2"
                      className='text-sm'
                      aria-label="Apps Permissions"
                      title="Contact details of Crewing Company"
                    >
                       <CopyCheckbox toggleCheckbox={toggleCheckbox} />
                    <div className='gap-4 grid grid-cols-12 mb-4'>
                      {
                        inputAccordion2?.map((item, index) => (
                          <div key={index} className={`${item.col} mt-3`}>
                            <item.component
                              register={register}
                              name={item.name}
                              type={item.type}
                              label={item.label}
                              radius={radius}
                              placement={placement}
                              options={item.options}
                              icon={item.icon}
                              maxLength={item.maxLength}
                            />
                          </div>  
                        ))
                      }
                      
                    </div>
                    <div className='col-md-6 mb-4'>
                      <label className='mb-4'>Phone Number of Contact Person</label>
                      <Controller
                        name="crew_manager_phone"
                        control={control}
                        className="form-control"
                        render={({ field: { onChange, value } }) => (
                          <PhoneInput
                            value={value}
                            enableSearch={true}
                            country={code}
                            onChange={(phoneValue, country) => {
                                setCode(country.countryCode)
                                onChange(phoneValue)
                            }}
                          />
                        )}
                      />
                    </div>
                  </AccordionItem>
                </Accordion>

            </div>

            {/* {JSON.stringify(formData)} */}

            <div className="row">

            <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">

                    <button className="btn btn-primary btn-informant" 
                        
                        onClick={() => {
                            setNavTab(navTab - 1)
                            setCurrent(current - 1)
                        }}
                    >Back<i className="icon-arrow-left1"></i></button>

                </div>

            </div>

            <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">
                <button className="btn btn-primary btn-informant" type="submit">Next <i className="icon-arrow-right1"></i></button>
                </div>

            </div>

            </div>

          </form>

        </div>
      </Spin>
    </div>

  )
}

export default AdditionalInfo

const shipTypeOptionsCreate =(shipType)=> {
  let ships = []
  if(shipType?.data?.data?.items.length > 0){
    shipType?.data?.data?.items?.map(item => {
      ships.push({name: item.type, value: item.id})
    })
    
  }

  return ships
}
